<template>
  <div>
    <v-card max-width="1030" class="mx-auto mt-5" id="busqueda">
      <v-card-title>
        <h4>SGS - Consulta de Obras</h4>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="buscarOdenPago" id="busqueda-form">
          <v-text-field
            type="text"
            label="Ingrese el nombre de la obra"
            hint="Ej. YPA% ..puede usar el signo % como comodin"
            v-model="nombreObra"
            maxlength="100"
          />
          <v-text-field
            type="text"
            label="Ingrese el nombre de algun autor"
            hint="Ej. BORGHETTI"
            v-model="nombreAutor"
            maxlength="100"
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="$router.push('/')">Volver</v-btn>
        <v-btn color="info" @click="buscar" :loading="loading">Buscar</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
      </v-card-actions>
    </v-card>

    <h5 class="mx-auto mt-5" v-if="loading">Cargando . . .</h5>
    <template v-if="obras.length > 0">
      <v-data-table
        :headers="headers"
        :items="obras"
        item-key="codWorkSq"
        class="elevation-1"
      >
      </v-data-table>
    </template>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      errorMessage: "",
      nombreObra: "",
      nombreAutor: "",
      headers: [
        {
          text: "Titulo Original",
          align: "start",
          sortable: false,
          value: "title"
        },
        { text: "CodWorkSq", value: "codWorkSq" },
        { text: "IdTema", value: "idTema" },
        { text: "ISWC", value: "iswc" },
        { text: "Autores", value: "autores" }
      ],
      obras: []
    };
  },
  methods: {
    buscar() {

      this.obras = [];
      this.errorMessage = "";
      
      this.loading = true;

      const params = {
        nombreObra: this.nombreObra.trim().length == 0 ? '%' : this.nombreObra.trim().toUpperCase(),
        nombreAutor: `${this.nombreAutor.trim().toUpperCase().replace(' ','%')}%`
      };

      axios
        .get("/sgs/obras", { params })
        .then(response => {
          this.obras = response.data;
          this.loading = false;
          if (this.obras.length == 0) {
            this.errorMessage = "No se encontraron coincidencias";
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = 'Error'
          }
          this.loading = false;
        });
    }
  }
};
</script>
